import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { style, trigger, state } from '@angular/animations';
import { BannerItemListModel } from '@components/slider/sideBanner/side-banner-slider.model';

@Component({
  selector: 'vertical-slider',
  templateUrl: './vertical-slider.component.html',
  animations: [
    trigger('slideInOut', [
      state('up', style({ transform: 'translateY({{offset}}px)' }), { params: { offset: 0 } }),
      state('down', style({ transform: 'translateY({{offset}}px)' }), { params: { offset: 0 } }),
    ]),
  ],
})
export class VerticalSliderComponent implements OnChanges, OnDestroy {
  @Input() items: BannerItemListModel;
  totalImages = 0;
  currentScrollIndex = 0;
  timer: any;
  direction: 'up' | 'down' = 'down';
  animState: any = { value: 'down', params: { offset: 0 } };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items.currentValue && changes.items.currentValue.sideBannerList.length > 0) {
      this.totalImages = this.items?.sideBannerList.length;
      if (this.totalImages > 3) {
        this.startAnimation();
      }
    }
  }

  startAnimation(): void {
    this.timer = setInterval(() => {
      if (this.direction === 'down' && this.currentScrollIndex < this.totalImages - 3) {
        this.currentScrollIndex++;
      } else if (this.direction === 'down') {
        this.direction = 'up';
      }

      if (this.direction === 'up' && this.currentScrollIndex > 0) {
        this.currentScrollIndex--;
      } else if (this.direction === 'up') {
        this.direction = 'down';
      }

      this.animState = {
        value: this.direction,
        params: { offset: this.currentScrollIndex * -246 },
      };
    }, 3000);
  }

  ngOnDestroy(): void {
    clearInterval(this.timer);
  }

  goToLink(e: string) {
    try {
      if (e.includes('http')) {
        window.location.href = e;
      } else {
        window.location.href = window.location.origin + e;
      }
    } catch (e) {
      console.warn(e);
    }
  }
}
